import React from 'react';
import { ActionBase } from '../ActionBase';
import { Store } from '../Store';
import { copyObject } from 'common/copyObject';
import { GetLoginDisplayItemResData } from 'requests/RequestLogin';

export const initialLoginDisplayItemData: GetLoginDisplayItemResData = {
	manage_id: '',
	site_cd: '',
	logo: '',
	title: '',
	title_size: 0,
	title_weight: 0,
	description: '',
	description_size: 0,
	description_weight: 0,
	redirect_url: '',
	member_regist_complete: '',
	terms_agree_complete: '',
	initial_registration_display_flg: 0,
	initial_registration_url: '',
	initial_registration_link_display: '',
	forget_password_display_flg: 0,
	footer_display_flg: 0,
};

//////////////////////////////////////////////////
// SaveAction
//////////////////////////////////////////////////
// Action
class SaveAction extends ActionBase {
	loginDisplayItemData: GetLoginDisplayItemResData;
}
// Action name
const SaveActionName = SaveAction.toString();

// Action generator
export const saveGenerator = async (
	dispatch: React.Dispatch<ActionBase>,
	loginDisplayItemData: GetLoginDisplayItemResData,
) => {
	const action = {
		action: SaveActionName,
		loginDisplayItemData: loginDisplayItemData,
	} as SaveAction;

	dispatch(action);
};

// Reducer
const saveReducer = (state: Store, action: ActionBase): Store => {
	const thisAction = action as SaveAction;
	const newState: Store = copyObject(state);
	newState.loginDisplayItemData = thisAction.loginDisplayItemData;
	return newState;
};

////////////////////////////////////////////////////////////////////////////////
// Reduce functions finder
////////////////////////////////////////////////////////////////////////////////
export const LoginDisplayItemReduceFunction = (state: Store, action: ActionBase): Store => {
	switch (action.action) {
		case SaveActionName:
			return saveReducer(state, action);
	}
	return null;
};
